import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { read } from "Helpers/LocalStorage";
import { getDesignUnitList } from "Stores/actions";
import { DESIGN_UNIT_LIST, SELECTED_PROJECT, SELECTED_UNIT_ID } from "Stores/actionTypes";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import DrawerService from "Services/http/endpoints/design/DrawerService";
import { push } from "Helpers/History";
import ToolsSideDrawer from "./components/ToolsSideDrawer/ToolsSideDrawer";
import DesignMain from "./components/DesignMain/DesignMain";
import UnitSideDrawer from "../components/UnitSideDrawer/UnitSideDrawer";

export default function Unit(props) {
  const dispatch = useDispatch();
  const { unitList, unitListPagination, selectedProject, rtlLayout } = useSelector((state) => ({
    unitList: state.design.unitList,
    unitListPagination: state.design.unitListPagination,
    selectedProject: state.project.selectedProject,
    rtlLayout: state.settings.rtlLayout
  }));
  const [firstLoad, setFirstLoad] = useState(true);
  const [loading, setLoading] = useState(true);
  const [sizeFontDesigner, setSizeFontDesigner] = useState(20);
  const [limitCouple, setLimitCouple] = useState(400);
  const [limitMulion, setLimitMulion] = useState(200);
  const [limitGuidLine, setLimitGuidLine] = useState(25);
  const [totalSetting, setTotalSetting] = useState(null);

  useEffect(() => {
    if(selectedProject && selectedProject !== "undefined") {
      (async () => {
        setFirstLoad(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdProject: selectedProject.Id
        }
        const unitSetting = await DrawerService.getSettingUnit(params);
        setSizeFontDesigner(unitSetting.data.Value.SizeFontDesigner);
        setLimitCouple(unitSetting.data.Value.LimitCouple);
        setLimitMulion(unitSetting.data.Value.LimitMulion);
        setLimitGuidLine(unitSetting.data.Value.LimitGuidLine);
        setTotalSetting(unitSetting.data.Value);
        setFirstLoad(false);
      })()
    } else {
      const _selectedProject = read("project");
      if(_selectedProject && _selectedProject !== "undefined") {
        dispatch({ type: SELECTED_PROJECT, selectedProject: _selectedProject });
        dispatch({ type: SELECTED_UNIT_ID, selectedUnitId: read("unitId") });
      } else {
        push("/dashboard/projects");
      }
    }
  },[selectedProject])

  const getData = async (Page, Limit = 20, update = true, reset = false, search = null) => {
    setLoading(true);
    try{
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        IdProject: selectedProject.Id,
        Limit, Page, ...search
      };
      const response = await dispatch(getDesignUnitList(params));
      if (update) {
        if(response) {
          const preData = unitList;
          const getedData = response.Value;
          let newUnitList = preData.concat(getedData);
          if(reset || Page === 1)
            newUnitList = getedData;
          setData(newUnitList, response.Pagination)
          setLoading(false);
        }
      } else {
        setLoading(false);
        return response;
      }
    } catch (e) {
      setLoading(false);
    }
  }

  const getOne = async (Id) => {
    setLoading(true);
    try{
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        IdProject: selectedProject.Id,
        Id, Limit: 1, Page: 1
      };
      const data = await dispatch(getDesignUnitList(params));
      setLoading(false);
      return data;
    } catch (e) {
      setLoading(false);
    }
  }

  const setData = (data, Pagination) => {
    dispatch({
      type: DESIGN_UNIT_LIST,
      unitList: data,
      unitListPagination: Pagination,
    });
  }
//{`designBase ${rtlLayout ? 'flex-row-reverse' : 'flex-row'}`}>
  return (
    <div className="design-panel">
      {/* <BackDropLoading loading={(firstLoad || loading)} /> */}
      {
        !firstLoad &&
        <>
          <ToolsSideDrawer rtl={rtlLayout}/>
          <DesignMain
            sizeFontDesigner={sizeFontDesigner}
            limitCouple={limitCouple}
            limitMulion={limitMulion}
            limitGuidLine={limitGuidLine}
            getUnitData={getData}
            getOneUnit={getOne}
            setUnitData={setData}
            totalSetting={totalSetting}
            parentLoading={firstLoad}
          />
          <UnitSideDrawer 
            getUnitData={getData}
            setUnitData={setData}
            parentLoading={loading}
            rtl={rtlLayout}
          />
        </>
      }
    </div>
  );
}